// extracted by mini-css-extract-plugin
export default {"BottomCTA":"BottomCTA_BottomCTA__YSAIg","CTACopy":"BottomCTA_CTACopy__-qgH7"};